import React from 'react';
import { Link } from 'react-router-dom';
import { Rocket, ArrowRight } from 'lucide-react';

const PilotBanner = () => (
  <div className="bg-gradient-to-r from-[#0A2540] to-[#0A2540]/90 border border-sky-900/30 rounded-2xl p-5 sm:p-6" data-testid="pilot-cta-banner">
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
      <div className="w-12 h-12 rounded-xl bg-[#0EA5E9]/20 flex items-center justify-center shrink-0">
        <Rocket className="w-6 h-6 text-[#0EA5E9]" />
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-1">
          <h4 className="text-sm font-semibold text-white" style={{fontFamily:'Syne,sans-serif'}}>Programa Piloto 30 días</h4>
          <span className="text-[10px] px-2 py-0.5 bg-[#F59E0B]/20 text-[#F59E0B] rounded-full font-semibold uppercase tracking-wider">Plazas limitadas</span>
        </div>
        <p className="text-xs text-slate-400">Prueba esta solución en tu operación real. Sin riesgo, con equipos reales y soporte dedicado.</p>
      </div>
      <Link to="/servicios/piloto" className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white bg-[#0EA5E9] rounded-xl hover:bg-sky-600 transition-colors whitespace-nowrap shadow-lg">
        Solicitar piloto <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  </div>
);

export default PilotBanner;
